import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../../hooks/useLocalizedPath';
import { Container, Button } from '../../ui';
import { ArrowDown } from 'lucide-react';
import { Co2Simulator } from './Co2Simulator';
import styles from './RepriseHero.module.css';

export function RepriseHero() {
  const { t } = useTranslation('reprise');
  const { lp } = useLocalizedPath();

  return (
    <div className={styles.hero}>
      <Container>
        <div className={styles.grid}>
          <div className={styles.content}>
            <span className={styles.kicker}>{t('hero.kicker')}</span>
            <h1 className={styles.title}>{t('hero.title')}</h1>
            <p className={styles.subtitle}>{t('hero.subtitle')}</p>
            <div className={styles.actions}>
              <Button href={lp('/contact')} data-attr="cta-contact">{t('hero.ctaPrimary')}</Button>
              <a href="#methode" className={styles.secondaryLink}>
                {t('hero.ctaSecondary')}
                <ArrowDown size={16} />
              </a>
            </div>
          </div>

          <div className={styles.aside}>
            <Co2Simulator />
          </div>
        </div>
      </Container>
    </div>
  );
}
